import { Component, OnInit, Input } from '@angular/core';
import { Chart } from 'chart.js';

@Component({
	selector: 'app-etnografia-data',
	templateUrl: './etnografia-data.component.html',
	styleUrls: ['./etnografia-data.component.scss'],
})
export class EtnografiaDataComponent implements OnInit {
	colors = ['#180064', '#2C009E', '#5B43D9', '#8F7FFF', '#5CDBBD'];
	etniaLabel = ['Negros', 'Pardos', 'Indígenas', 'Brancos', 'Amarelos'];

	constructor() {}
	@Input() dataAgressions: any;
	@Input() elId: string;

	dataSetAge: any = [];
	dataSetColor: any = [];
	ngOnInit(): void {
		this.createGraphOfGender();
		this.createGraphOfEtnia();
		this.createGraphOfAge();
	}

	ngOnChanges() {
		this.createGraphOfGender();
		this.createGraphOfEtnia();
		this.createGraphOfAge();
	}

	genderChart: Chart | null = null;
	noGenderData: boolean = false;
	createGraphOfGender() {
		const canvas = document.getElementById(
			this.elId + 'myChartGender'
		) as HTMLCanvasElement;

		const ctx = canvas?.getContext('2d');

		let genero = this.dataAgressions?.category_counts?.gender;

		this.noGenderData =
			Object.keys(genero).filter((el) => el != 'Dado ausente').length === 0;

		if (genero && !this.noGenderData) {
			var data = {
				labels: ['Homens', 'Mulheres', 'Não binário'],
				datasets: [
					{
						label: 'Cisgênero',
						backgroundColor: '#180064',
						data: [genero['Homem cis'], genero['Mulher cis'] ?? 0], // Valores para homens e mulheres cisgênero
					},
					{
						label: 'Transgênero',
						backgroundColor: '#9085DE',
						data: [genero['Homem trans'], genero['Mulher trans'] ?? 0], // Valores para homens e mulheres transgênero
					},
					{
						label: 'Não binário',
						backgroundColor: '#5CDBBD',
						data: [0, 0, genero['Não binário']], // Valores para homens e mulheres transgênero
					},
				],
			};

			if (this.genderChart) this.genderChart.destroy();

			this.genderChart = new Chart(ctx, {
				type: 'bar',
				data: data,
				options: {
					responsive: true,
					tooltips: {
						callbacks: {
							label: function (tooltipItem, data) {
								let dataset = data.datasets[tooltipItem.datasetIndex];
								let index = tooltipItem.index;
								let datasetData = dataset.data as number[];
								console.log(data.datasets);
								let total = data.datasets.reduce(
									(a, b) => a + (b.data as number[]).reduce((c, d) => c + d, 0),
									0
								);
								total += genero['Dado ausente'];
								let percentage = (datasetData[index] / total) * 100; // calculate percentage
								return `${dataset.label}: ${
									datasetData[index]
								} (${percentage.toFixed(2)}%)`;
							},
						},
					},
					legend: {
						display: false,
						position: 'bottom', // Posição da legenda
						align: 'center', // Alinhamento da legenda
						labels: {
							usePointStyle: false, // Usar estilo de ponto (cor do item da legenda)
							boxWidth: 12, // Tamanho da caixa da legenda
							fontColor: '#938F94', // Cor da fonte da legenda
						},
					},
					scales: {
						xAxes: [
							{
								ticks: {
									beginAtZero: true,
								},
								gridLines: {
									display: false,
								},
							},
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									fontColor: '#938F94',
								},
								gridLines: {
									color: 'rgba(229,222,255)', // Cor do grid x
									borderDash: [10, 5], // Padrão de traço (5 pixels sólidos, 5 pixels vazios)
									borderDashOffset: 10, // Deslocamento do padrão de traço
									drawBorder: false, // Não desenhar a borda do gráfico
									//drawOnChartArea: false, // Não desenhar sobre a área do gráfico
									drawTicks: false, // Não desenhar os ticks,
									zeroLineColor: 'rgba(229,222,255)', // Cor da linha zero
									zeroLineBorderDash: [10, 5], // Padrão de traço da linha zero
									zeroLineBorderDashOffset: 10, // Deslocamento do padrã
								},
							},
						],
					},
				},
			});
		}
	}

	ageChart: Chart | null = null;
	noAgeData: boolean = false;
	createGraphOfAge() {
		const canvas = document.getElementById(
			this.elId + 'myChartAge'
		) as HTMLCanvasElement;
		const ctx = canvas.getContext('2d');

		let age = this.dataAgressions?.category_counts?.age_group;

		this.noAgeData =
			Object.keys(age).filter((el) => el != 'Dado ausente').length === 0;

		const agePercentages =
			this.dataAgressions?.category_counts_percentage.age_group;

		if (age) {
			let key = Object.keys(age);
			let value = Object.values(age);
			key = this.removerStringDaLista(key, 'NOT_INFORMED');

			key = key.sort((a, b) => parseInt(a) - parseInt(b));

			let dataSet = [];
			key.forEach((age, index) => {
				if (key[index] === 'Dado ausente') return;

				dataSet.push({
					label: key[index],
					data: [value[index]],
					backgroundColor: this.colors[index % 5],
					barPercentage: 0.6,
					categoryPercentage: 0.8,
				});
			});

			this.dataSetAge = dataSet;

			var data = {
				labels: [''],
				datasets: dataSet,
			};

			if (this.ageChart) this.ageChart.destroy();

			this.ageChart = new Chart(ctx, {
				type: 'bar',
				data: data,
				options: {
					responsive: true,

					tooltips: {
						callbacks: {
							label: function (tooltipItem, data) {
								var dataset = data.datasets[tooltipItem.datasetIndex];
								var index = tooltipItem.index;
								return `${dataset.label}: ${dataset.data[index]} (${
									agePercentages[dataset.label]
								})`;
							},
						},
					},

					legend: {
						display: false,
						position: 'bottom', // Posição da legenda
						align: 'center', // Alinhamento da legenda
						labels: {
							usePointStyle: false, // Usar estilo de ponto (cor do item da legenda)
							boxWidth: 12, // Tamanho da caixa da legenda
							fontColor: '#938F94', // Cor da fonte da legenda
						},
					},
					scales: {
						xAxes: [
							{
								ticks: {
									beginAtZero: true,
								},
								gridLines: {
									display: false,
								},
							},
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									fontColor: '#938F94',
								},
								gridLines: {
									color: 'rgba(229,222,255)', // Cor do grid x
									borderDash: [10, 5], // Padrão de traço (5 pixels sólidos, 5 pixels vazios)
									borderDashOffset: 10, // Deslocamento do padrão de traço
									drawBorder: false, // Não desenhar a borda do gráfico
									//drawOnChartArea: false, // Não desenhar sobre a área do gráfico
									drawTicks: false, // Não desenhar os ticks,
									zeroLineColor: 'rgba(229,222,255)', // Cor da linha zero
									zeroLineBorderDash: [10, 5], // Padrão de traço da linha zero
									zeroLineBorderDashOffset: 10, // Deslocamento do padrã
								},
							},
						],
					},
				},
			});
		}
	}

	removerStringDaLista(lista, stringAlvo) {
		return lista.filter((item) => item !== stringAlvo);
	}

	etniaChart: Chart | null = null;
	noEtniaData: boolean = false;
	createGraphOfEtnia() {
		const etniaPercentages =
			this.dataAgressions?.category_counts_percentage.ethnicity;

		const canvas = document.getElementById(
			this.elId + 'myChartCasesOfEtnia'
		) as HTMLCanvasElement;
		const ctx = canvas.getContext('2d');

		let etnia = this.dataAgressions?.category_counts?.ethnicity;

		this.noEtniaData =
			Object.keys(etnia).filter((el) => el != 'Dado ausente').length === 0;

		if (etnia) {
			let key = Object.keys(etnia);
			let value = Object.values(etnia);

			let dataSet = [];

			key.forEach((etnia, index) => {
				if (key[index] === 'Dado ausente') return;

				dataSet.push({
					label: key[index],
					data: [value[index]],
					backgroundColor: this.colors[index % 5],
					barPercentage: 0.6,
					categoryPercentage: 0.8,
				});
			});

			this.dataSetColor = dataSet;

			var data = {
				labels: [''],
				datasets: dataSet,
			};

			if (this.etniaChart) this.etniaChart.destroy();

			this.etniaChart = new Chart(ctx, {
				type: 'bar',
				data: data,
				options: {
					responsive: true,

					tooltips: {
						callbacks: {
							label: function (tooltipItem, data) {
								var dataset = data.datasets[tooltipItem.datasetIndex];
								var index = tooltipItem.index;
								return `${dataset.label}: ${dataset.data[index]} (${
									etniaPercentages[dataset.label]
								})`;
							},
						},
					},

					legend: {
						display: false,
						position: 'bottom', // Posição da legenda
						align: 'center', // Alinhamento da legenda
						labels: {
							usePointStyle: false, // Usar estilo de ponto (cor do item da legenda)
							boxWidth: 12, // Tamanho da caixa da legenda
							fontColor: '#938F94', // Cor da fonte da legenda
						},
					},
					scales: {
						xAxes: [
							{
								ticks: {
									beginAtZero: true,
								},
								gridLines: {
									display: false,
								},
							},
						],
						yAxes: [
							{
								ticks: {
									beginAtZero: true,
									fontColor: '#938F94',
								},
								gridLines: {
									color: 'rgba(229,222,255)', // Cor do grid x
									borderDash: [10, 5], // Padrão de traço (5 pixels sólidos, 5 pixels vazios)
									borderDashOffset: 10, // Deslocamento do padrão de traço
									drawBorder: false, // Não desenhar a borda do gráfico
									//drawOnChartArea: false, // Não desenhar sobre a área do gráfico
									drawTicks: false, // Não desenhar os ticks,
									zeroLineColor: 'rgba(229,222,255)', // Cor da linha zero
									zeroLineBorderDash: [10, 5], // Padrão de traço da linha zero
									zeroLineBorderDashOffset: 10, // Deslocamento do padrã
								},
							},
						],
					},
				},
			});
		}
	}
}
